import React from "react";
import { useTranslation } from "react-i18next";
import useLanguage from "../../utils/useLanguage";
import { formatDate } from "../../utils/toDate";

const PrintableSupplieUniform = React.forwardRef(
  ({ data, currency, orderDetails }, ref) => {
    const { currentDirection } = useLanguage();
    const { t } = useTranslation("general");

    const {
      orderNumber = "",
      date = new Date().toLocaleDateString(),
      companyName = "",
      notes = "",
      createdBy = "",
    } = orderDetails || {};

    // Transform the grouped data structure into flat structure for printing
    const allUniforms =
      data?.reduce((acc, category) => {
        category.sizes.forEach((uniform) => {
          acc.push({
            ...uniform,
            categoryName: category.name,
          });
        });
        return acc;
      }, []) || [];

    // Group uniforms by category for display
    const groupedUniforms = data || [];

    return (
      <div
        ref={ref}
        className="printable-order-view"
        dir={currentDirection}
        style={{ display: "none" }}
      >
        <section className="print-first-section">
          <div className="u-margin--bottom_500">
            <h1 className="headerTitle">{t("suppliesUniformList")}</h1>
          </div>

          {/* Order information section */}
          <div className="print-info-section">
            <div className="print-info-row">
              <div className="print-info-block">
                <div className="print-info-item">
                  <strong>{t("Date")}:</strong> {formatDate(date)}
                </div>
                <div className="print-info-item">
                  <strong>{t("orderNumber")}:</strong> {orderNumber}
                </div>
              </div>
              <div className="print-info-block">
                <div className="print-info-item">
                  <strong>{t("organizationName")}:</strong> {companyName}
                </div>
                  <div className="print-info-item">
                    <strong>{t("creator")}:</strong> {createdBy}
                  </div>
              </div>
            </div>
          </div>

          {/* Grouped uniform items */}
          {groupedUniforms.map((group) => (
            <div key={group.id} className="print-paper-group">
              <div
                style={{
                  border: "1px solid #ddd",
                  padding: "8px",
                  backgroundColor: "#f2f2f2",
                }}
              >
                <div>
                  <strong>{t("uniformName")}: </strong>
                  <span>{group.name}</span>
                </div>
                <div className="u-margin--top_300">
                  <strong>{t("color")}: </strong>
                  <span>{group.color}</span>
                </div>
              </div>
              <table className="print-fabric-table">
                <thead>
                  <tr>
                    <th>{t("size")}</th>
                    <th>{t("quantity")}</th>
                  </tr>
                </thead>
                <tbody>
                  {group.sizes.map((uniform, index) => (
                    <tr key={index}>
                      <td>{uniform.size}</td>
                      <td>{uniform.quantity}</td>

                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ))}
        </section>

        <section className="print-notes-section">
          <h2>{t("notes")}: </h2>
          <p>{notes}</p>
        </section>

        <section className="print-footer u-margin--top_auto">
          <p className="t-headline-3">{t("ehsiblySecondSlogan")}</p>
          <p>{t("alhabbarSlogan")}</p>
        </section>
      </div>
    );
  }
);

export default PrintableSupplieUniform;
